import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import sanitizeHtml from 'sanitize-html';

import Carousel from '../../Carousel/Carousel';
import Icon from '../../Icon/Icon';
import Grid from '../../Grid/Grid';
import Label from '../../Label/Label';
import { ICONS } from '../../../constants';
import { createMarkup } from '../../../helpers';
import withResponsiveWrapper from '../../../decorators/withResponsiveWrapper';
// eslint-disable-next-line css-modules/no-unused-class
import s from '../../../routes/product/Product.scss';

const Usps = ({ usps, isMobile }) => {
  return isMobile ? (
    <Carousel
      arrows
      arrowClass="basic"
      className={s.usps}
      ariaLabel="Unique product features"
    >
      {usps.map(({ content, icon, ...rest }) => (
        <div className={s.carousel__label} key={icon}>
          <Icon
            name={ICONS[icon]}
            size={24}
            className={s.carousel__icon}
            {...rest}
          />
          <p
            className={s.carousel__text}
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}
          />
        </div>
      ))}
    </Carousel>
  ) : (
    <Grid
      container
      spacing={16}
      component="ul"
      alignItems="center"
      justify="center"
    >
      {usps &&
        usps.map(({ content, icon, ...rest }) =>
          content ? (
            <Grid key={icon} component="li" item sm={24 / usps.length}>
              <Label icon={{ name: ICONS[icon], size: 24, ...rest }}>
                <span dangerouslySetInnerHTML={createMarkup(content)} />
              </Label>
            </Grid>
          ) : null,
        )}
    </Grid>
  );
};

export default compose(withResponsiveWrapper())(Usps);

Usps.propTypes = {
  usps: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
    }),
  ).isRequired,
  isMobile: PropTypes.bool.isRequired,
};
